/**
 * useToken - 認証トークン取得フック
 *
 * URLクエリパラメータを優先し、sessionStorageをフォールバックとして使用。
 * Flutter WebViewからURLで受け取ったtokenをsessionStorageに保存し、
 * React Router遷移中にURLからtokenが消失してもAPI呼び出しで使用可能にする。
 */

import { useSearchParams } from 'react-router-dom';
import { tokenStorage } from '../services/tokenStorage';

export const useToken = (): string | undefined => {
  const [searchParams] = useSearchParams();
  const urlToken = searchParams.get('token');

  // URLにtokenがあればsessionStorageに保存して返す
  if (urlToken) {
    tokenStorage.save(urlToken);
    return urlToken;
  }

  // URLになければsessionStorageから取得
  return tokenStorage.get();
};
